var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeftreact = function SvgArrowLeftreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H11.982A13.7 13.7 0 0 0 0 12.151S9.329 11.362 12.288 0H24s-1.325 11.489-12.067 11.933c0 .001 10.138-.772 12.067 12.067Z"
  })));
};

export default SvgArrowLeftreact;